import React, { FC, useEffect, useState } from 'react';
import {
  Table,
  TableData,
  TableRow,
  checkIfAllSelected,
  updateAllSelections,
  updateSelection
} from '@cokitchen/cokitchen-components';
import { PaymentHistoryType } from 'models/payment.model';
import { PartnerType } from 'models/partner.model';
import { formatNumber, getSimpleDateFormat } from 'utils/functions';

const TABLE_HEADERS = ['Partner name', 'Trip revenue', 'Amount paid', 'Date paid', 'Notes'];

const PaymentHistoryList: FC<{ data: PaymentHistoryType[] }> = ({ data }) => {
  // TODO :: remove Partial<T> when api is implemented
  const getInitials = (partner: Partial<PartnerType>) => {
    const [first, last] = partner.name?.split(' ') ?? [];
    return `${first[0]?.toUpperCase()}${last[0]?.toUpperCase()}`;
  };

  const [selected, setSelected] = useState<string[]>([]);
  const [isAllSelected, setAllSelected] = useState(false);

  const updateSelections = () => {
    setSelected(updateAllSelections(data, selected, isAllSelected));
  };

  useEffect(() => {
    setAllSelected(checkIfAllSelected(data, selected));
  }, [selected]);

  const updateSingleSelection = (id: string) => {
    setSelected(updateSelection(selected, id));
  };

  return (
    <Table
      headers={TABLE_HEADERS}
      canSelect
      isAllSelected={isAllSelected}
      onToggleAll={updateSelections}>
      {data?.map((h, index) => {
        return (
          <TableRow
            key={index}
            canSelect
            isSelected={selected.includes(h.id)}
            onToggle={() => updateSingleSelection(h.id)}>
            <TableData className='py-6'>
              <span className='rounded-full bg-blue-1 border border-blue-2 inline-flex items-center justify-center w-[28px] h-[28px] mr-3 text-xs text-blue-5'>
                {getInitials(h.partner)}
              </span>
              <span>{h.partner?.name ?? ''}</span>
            </TableData>
            <TableData>{formatNumber(h.tripRevenue)}</TableData>
            <TableData>{formatNumber(h.amountPaid)}</TableData>
            <TableData>
              <span>{getSimpleDateFormat(h.datePaid)}</span>
            </TableData>
            <TableData>{h.notes || '-'}</TableData>
          </TableRow>
        );
      })}
    </Table>
  );
};

export default PaymentHistoryList;
